export class Profile {
  constructor() {
    this.SESSION_TOKEN_KEY = 'apiKey'
    this.SESSION_EMAIL_KEY = 'email'
  }

  storeSessionToken(payload) {
    const { apiKey, email } = payload
    sessionStorage.setItem(this.SESSION_TOKEN_KEY, apiKey)
    sessionStorage.setItem(this.SESSION_EMAIL_KEY, email)
  }

  getSessionToken() {
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem(this.SESSION_TOKEN_KEY)) {
        let apiKey = sessionStorage.getItem(this.SESSION_TOKEN_KEY)
        let email = sessionStorage.getItem(this.SESSION_EMAIL_KEY)
        resolve({ apiKey, email })
      } else {
        reject(Error('no key found'))
      }
    })
  }

  deleteSessionToken() {
    sessionStorage.removeItem(this.SESSION_TOKEN_KEY)
    sessionStorage.removeItem(this.SESSION_EMAIL_KEY)
  }
}

// The singleton variable
export let userProfile = new Profile()
